import { CONFIG_ACTIONS_KEYS, CONFIG_GETTERS_KEYS, CONFIG_MUTATIONS_KEYS } from './config/config.const';
import { CORE_ACTIONS_KEYS, CORE_MUTATIONS_KEYS } from './core/core.const';
import { EMPATHIZE_ACTIONS_KEYS, EMPATHIZE_GETTERS_KEYS, EMPATHIZE_MUTATIONS_KEYS } from './empathize/empathize.const';
import { EMPTY_SEARCH_ACTIONS_KEYS, EMPTY_SEARCH_GETTERS_KEYS, EMPTY_SEARCH_MUTATIONS_KEYS } from './empty-search/empty-search.const';
import { HISTORY_ACTIONS_KEYS, HISTORY_GETTERS_KEYS, HISTORY_MUTATIONS_KEYS } from './history/history.const';
import { NO_RESULTS_ACTIONS_KEYS, NO_RESULTS_GETTERS_KEYS, NO_RESULTS_MUTATIONS_KEYS } from './no-results/no-results.const';
import { QUERY_SIGNALS_ACTIONS_KEYS, QUERY_SIGNALS_GETTERS_KEYS, QUERY_SIGNALS_MUTATIONS_KEYS } from './query-signals/query-signals.const';
import { SEARCH_ACTIONS_KEYS, SEARCH_GETTERS_KEYS, SEARCH_MUTATIONS_KEYS } from './search/search.const';
import { TRACKING_ACTIONS_KEYS, TRACKING_MUTATIONS_KEYS } from './tracking/tracking.const';
import { URL_ACTIONS_KEYS, URL_GETTERS_KEYS, URL_MUTATIONS_KEYS } from './url/url.const';

export const SUBMODULES_PATHS = {
  config: 'config',
  core: 'core',
  empathize: 'empathize',
  emptySearch: 'emptySearch',
  history: 'history',
  noResults: 'noResults',
  querySignals: 'querySignals',
  search: 'search',
  tracking: 'tracking',
  url: 'url'
} as const;

export const ACTIONS_KEYS = {
  config: addRelativePath(SUBMODULES_PATHS.config, CONFIG_ACTIONS_KEYS),
  core: addRelativePath(SUBMODULES_PATHS.core, CORE_ACTIONS_KEYS),
  empathize: addRelativePath(SUBMODULES_PATHS.empathize, EMPATHIZE_ACTIONS_KEYS),
  emptySearch: addRelativePath(SUBMODULES_PATHS.emptySearch, EMPTY_SEARCH_ACTIONS_KEYS),
  history: addRelativePath(SUBMODULES_PATHS.history, HISTORY_ACTIONS_KEYS),
  noResults: addRelativePath(SUBMODULES_PATHS.noResults, NO_RESULTS_ACTIONS_KEYS),
  querySignals: addRelativePath(SUBMODULES_PATHS.querySignals, QUERY_SIGNALS_ACTIONS_KEYS),
  search: addRelativePath(SUBMODULES_PATHS.search, SEARCH_ACTIONS_KEYS),
  tracking: addRelativePath(SUBMODULES_PATHS.tracking, TRACKING_ACTIONS_KEYS),
  url: addRelativePath(SUBMODULES_PATHS.url, URL_ACTIONS_KEYS)
};

export const MUTATIONS_KEYS = {
  config: addRelativePath(SUBMODULES_PATHS.config, CONFIG_MUTATIONS_KEYS),
  core: addRelativePath(SUBMODULES_PATHS.core, CORE_MUTATIONS_KEYS),
  empathize: addRelativePath(SUBMODULES_PATHS.empathize, EMPATHIZE_MUTATIONS_KEYS),
  emptySearch: addRelativePath(SUBMODULES_PATHS.emptySearch, EMPTY_SEARCH_MUTATIONS_KEYS),
  history: addRelativePath(SUBMODULES_PATHS.history, HISTORY_MUTATIONS_KEYS),
  noResults: addRelativePath(SUBMODULES_PATHS.noResults, NO_RESULTS_MUTATIONS_KEYS),
  querySignals: addRelativePath(SUBMODULES_PATHS.querySignals, QUERY_SIGNALS_MUTATIONS_KEYS),
  search: addRelativePath(SUBMODULES_PATHS.search, SEARCH_MUTATIONS_KEYS),
  tracking: addRelativePath(SUBMODULES_PATHS.tracking, TRACKING_MUTATIONS_KEYS),
  url: addRelativePath(SUBMODULES_PATHS.url, URL_MUTATIONS_KEYS)
};

export const GETTERS_KEYS = {
  config: addRelativePath(SUBMODULES_PATHS.config, CONFIG_GETTERS_KEYS),
  empathize: addRelativePath(SUBMODULES_PATHS.empathize, EMPATHIZE_GETTERS_KEYS),
  emptySearch: addRelativePath(SUBMODULES_PATHS.emptySearch, EMPTY_SEARCH_GETTERS_KEYS),
  history: addRelativePath(SUBMODULES_PATHS.history, HISTORY_GETTERS_KEYS),
  search: addRelativePath(SUBMODULES_PATHS.search, SEARCH_GETTERS_KEYS),
  url: addRelativePath(SUBMODULES_PATHS.url, URL_GETTERS_KEYS),
  noResults: addRelativePath(SUBMODULES_PATHS.noResults, NO_RESULTS_GETTERS_KEYS),
  querySignals: addRelativePath(SUBMODULES_PATHS.querySignals, QUERY_SIGNALS_GETTERS_KEYS)
};

/* I know this function is a bit confusing, but it purpose is just adding the path to each action, mutation and getter */
function addRelativePath<T>(path: string, configObject: T): Record<keyof T, string> {
  return Object.entries(configObject)
    .reduce((keysObject, [name, key]) => {
      keysObject[name as keyof T] = `${ path }/${ key }`;
      return keysObject;
    }, {} as Record<keyof T, string>);
}
